import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    addWhenEmpty: Boolean,
    destroyBehaviour: { type: String, default: "remove" },
    rowLimit: Number,
  };

  static targets = ["addButton", "container", "template"];

  declare addWhenEmptyValue: boolean;
  declare destroyBehaviourValue: string;
  declare rowLimitValue: number;
  declare hasAddButtonTarget: boolean;
  declare hasRowLimitValue: boolean;

  declare addButtonTarget: HTMLButtonElement;
  declare containerTarget: HTMLElement;
  declare templateTarget: HTMLTemplateElement;

  connect(): void {
    this.toggleAddButtonState();
  }

  add(evt?: Event): void {
    const template = this.templateTarget.content.cloneNode(true) as DocumentFragment;
    const fieldGroup = template.querySelector(".nested-form-wrapper") as HTMLElement;

    // Update field names to be unique
    const timestamp = Date.now();
    fieldGroup.querySelectorAll("input, select").forEach((element) => {
      const currentName = (element as HTMLInputElement | HTMLSelectElement).name;
      (element as HTMLInputElement | HTMLSelectElement).name = currentName.replace(
        "NEW_RECORD",
        timestamp.toString(),
      );
    });
    this.containerTarget.appendChild(template);

    this.toggleAddButtonState();
  }

  remove(event: Event): void {
    const button = event.target as HTMLElement;
    const fieldGroup = button.closest(".nested-form-wrapper") as HTMLElement;

    if (this.destroyBehaviourValue === "remove") {
      fieldGroup.remove();
    } else {
      // TODO: This may not be required, investigate if it's needed
      const inputs: NodeListOf<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> =
        fieldGroup.querySelectorAll('input:not([type="hidden"]), textarea, select');
      inputs.forEach((input) => {
        input.disabled = true;
      });

      if (fieldGroup.dataset.newRecord === "true") {
        fieldGroup.remove();
      } else {
        fieldGroup.style.display = "none";
        // Mark the fieldGroup as destroyed so it doesn't count towards the row limit
        fieldGroup.setAttribute("data-destroyed", "true");

        const input: HTMLInputElement | null = fieldGroup?.querySelector("input[name*='_destroy']");
        if (input) {
          input.value = "1";
        }
      }
    }

    if (
      this.addWhenEmptyValue &&
      this.containerTarget.querySelectorAll(".nested-form-wrapper").length === 0
    ) {
      this.add();
    }

    this.toggleAddButtonState();
  }

  toggleAddButtonState() {
    if (!this.hasAddButtonTarget || !this.hasRowLimitValue) {
      return;
    }

    const currentRowCount = this.element.querySelectorAll(
      ".nested-form-wrapper:not([data-destroyed])",
    ).length;

    if (currentRowCount >= this.rowLimitValue) {
      this.addButtonTarget.disabled = true;
    } else {
      this.addButtonTarget.disabled = false;
    }
  }
}
